module.exports = __webpack_public_path__ + "static/media/favicon.125c16c6.ico";


//////////////////
// WEBPACK FOOTER
// ./node_modules/loyal-design-system/skins/porto-seguro-fidelidade/favicon.ico
// module id = 1850
// module chunks = 11